export default __webpack_public_path__ + "3d05f2fd283f8e8f1d320fb602cd54a6.png";